import * as types from '../actions/actionTypes';

const initialState = {
  faqs: [],
  faqs_servicios: [],
  faqs_problems: [],
  faqs_instructions: [],
  faqs_seguridad: [],
  commerces: [],
  loading: false,
  error: ''
}

const apiState = (state = initialState, action) => {
  switch (action.type) {
    case types.STORE_FAQS: {
      return {
        ...state,
        faqs: action.payload.faqs,
        loadig: action.payload.loadig
      }
    }
    case types.SENDING_REQUEST: {
      return {
        ...state,
        loading: action.payload.loadig,
      }
    }
    case types.FAQS_REQUEST_DATA: {
      return {
        ...state,
        faqs: action.payload.faqs,
        loading: action.payload.loadig,
      }
    }
    case types.FAQS_SERVICIOS_CP: {
      return {
        ...state,
        faqs_servicios: action.payload.faqs_servicios,
        loadig: action.payload.loadig
      }
    }
    case types.FAQS_PROBLEMAS: {
      return {
        ...state,
        faqs_problems: action.payload.faqs_problems,
        loadig: action.payload.loadig
      }
    }
    case types.FAQS_INSTRUCCIONES: {
      return {
        ...state,
        faqs_instructions: action.payload.faqs_instructions,
        loading: action.payload.loadig
      }
    }
    case types.FAQS_SEGURIDAD: {
      return {
        ...state,
        faqs_seguridad: action.payload.faqs_seguridad,
        loadig: action.payload.loadig
      }
    }
    case types.REQUEST_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: action.payload.loadig
      }
    }
    case types.STORE_COMERCES: {
      return {
        ...state,
        commerces: action.payload.commerces,
        loading: action.payload.loadig
      }
    }
    default: return state;
  }
}

export default apiState;